"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FiltersPanel = void 0;
var _react = _interopRequireDefault(require("react"));
var _IssueFilterForm = require("../IssueFilterForm");
var _accReferencePicker = require("@adsk/acc-reference-picker");
var _alloyReactPanel = _interopRequireDefault(require("@adsk/alloy-react-panel"));
var _useTranslations = require("../utils/i18n/useTranslations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FiltersPanel = _ref => {
  var _T$translate;
  let {
    filters: {
      searchExpression,
      ...filters
    },
    setFilters,
    open,
    floatingPanel,
    onClose,
    hasFilters,
    clearFilters,
    fixedTypeId
  } = _ref;
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const title = (_T$translate = T.translate("filterPanel.title")) === null || _T$translate === void 0 ? void 0 : _T$translate.toString();
  return /*#__PURE__*/_react.default.createElement(_alloyReactPanel.default, {
    open: open,
    floating: floatingPanel,
    renderHeader: () => /*#__PURE__*/_react.default.createElement(_accReferencePicker.FiltersHeader, {
      floatingPanel: floatingPanel,
      onClose: onClose,
      title: title,
      hasFilters: hasFilters,
      clearFilters: clearFilters
    })
  }, /*#__PURE__*/_react.default.createElement(_alloyReactPanel.default.Body, {
    style: {
      padding: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_IssueFilterForm.IssueFilterForm, {
    style: {
      height: "100%"
    },
    filters: filters,
    handleFilterChange: filtersDiff => {
      setFilters({
        ...filters,
        ...filtersDiff
      });
    },
    fixedTypeId: fixedTypeId
  })));
};
exports.FiltersPanel = FiltersPanel;
//# sourceMappingURL=FiltersPanel.js.map